import routesGenerator from '@/router/routesGenerator';
import { actionToPath } from 'redux-first-router';
import { useTypeformDrawer } from './useTypeformDrawer';
import { useLocation } from './useLocation';
import { useLocale } from './useLocale';

const routesMap = routesGenerator();

export function useI18nFeedback(statementdId?: string) {
  const locale = useLocale();
  const location = useLocation();
  const currentPath = actionToPath(location, routesMap);

  const feedbackIdMap = {
    es: 'hhQKsh1e',
    de: 'G5mWOwKv',
    ja: 'a3enSUNp',
    ko: 'jK89Qvjn',
    fr: 'JtFZpox8',
    it: 'wvTU4SIp',
    nl: 'ezCaLiPl',
    tr: 'WrCw4CIG',
    default: 'UjJqoRzy',
  } as const;
  const makeFeedbackDrawer = useTypeformDrawer(
    locale in feedbackIdMap ? feedbackIdMap[locale] : feedbackIdMap.default,
    {
      locale,
      canonical_url: currentPath,
      device_type: RUNTIME_ENV,
      statement_id: statementdId,
    }
  );
  return makeFeedbackDrawer;
}
